import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const FIPGL23_ID = 'acb52946-e2a8-4fac-84db-04865b85f944';
const BROILER_ID = '408634a3-a463-43e8-b01e-2e55ce7ad9fb';

export default function UrunOlustur() {
  const navigate = useNavigate();
  const { id } = useParams();
  const duzenle = !!id && id !== 'yeni';
  const [firmalar, setFirmalar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [form, setForm] = useState({
    firma_id: '', alt_grup: '', ad: '',
    maliyet: '',
    satis_tipi: 'veteriner',
    banka_fiyat_kdvsiz: '', kk_fiyat_kdvli: '',
    hya_banka_fiyat: '', hya_kk_fiyat: '',
    bireysel_komisyon: '', kurumsal_komisyon: '',
    hya_bireysel_komisyon: '', hya_kurumsal_komisyon: '',
    // Broiler fiyatları
    ciftlik_fiyat: '',        // KDV'siz
    ciftlik_fiyat_kdvli: '',  // KDV'li
    ciftlik_komisyon: '',
    bayi_fiyat: '',           // KDV'siz
    bayi_fiyat_kdvli: '',     // KDV'li
    bayi_komisyon: '',
    entegre_fiyat: '',        // Sadece KDV'li
    entegre_komisyon: '',
    komisyonsuz: false, aktif: true,
  });

  useEffect(() => {
    async function loadData() {
      const { data: fData } = await supabase.from('firmalar').select('id, ad').eq('aktif', true);
      setFirmalar(fData || []);
      if (duzenle) {
        const { data } = await supabase.from('urunler').select('*').eq('id', id).single();
        if (data) {
          setForm({
            firma_id: data.firma_id || '', alt_grup: data.alt_grup || '', ad: data.ad || '',
            maliyet: data.maliyet || '',
            satis_tipi: data.satis_tipi || 'veteriner',
            banka_fiyat_kdvsiz: data.banka_fiyat_kdvsiz || '', kk_fiyat_kdvli: data.kk_fiyat_kdvli || '',
            hya_banka_fiyat: data.hya_banka_fiyat || '', hya_kk_fiyat: data.hya_kk_fiyat || '',
            bireysel_komisyon: data.bireysel_komisyon || '', kurumsal_komisyon: data.kurumsal_komisyon || '',
            hya_bireysel_komisyon: data.hya_bireysel_komisyon || '', hya_kurumsal_komisyon: data.hya_kurumsal_komisyon || '',
            ciftlik_fiyat: data.ciftlik_fiyat || '',
            ciftlik_fiyat_kdvli: data.ciftlik_fiyat_kdvli || '',
            ciftlik_komisyon: data.ciftlik_komisyon || '',
            bayi_fiyat: data.bayi_fiyat || '',
            bayi_fiyat_kdvli: data.bayi_fiyat_kdvli || '',
            bayi_komisyon: data.bayi_komisyon || '',
            entegre_fiyat: data.entegre_fiyat || '',
            entegre_komisyon: data.entegre_komisyon || '',
            komisyonsuz: data.komisyonsuz || false, aktif: data.aktif !== false,
          });
        }
      }
    }
    loadData();
  }, [id, duzenle]);

  function f(key, val) { setForm(p => ({ ...p, [key]: val })); }

  async function handleKaydet() {
    if (!form.firma_id || !form.ad) { setHata('Firma ve ürün adı zorunlu!'); return; }
    setYukleniyor(true);
    const payload = {
      firma_id: form.firma_id, grup: null, alt_grup: form.alt_grup, ad: form.ad,
      maliyet: parseFloat(form.maliyet) || 0,
      satis_tipi: form.satis_tipi,
      banka_fiyat_kdvsiz: parseFloat(form.banka_fiyat_kdvsiz) || 0,
      kk_fiyat_kdvli: parseFloat(form.kk_fiyat_kdvli) || 0,
      hya_banka_fiyat: parseFloat(form.hya_banka_fiyat) || 0,
      hya_kk_fiyat: parseFloat(form.hya_kk_fiyat) || 0,
      bireysel_komisyon: parseFloat(form.bireysel_komisyon) || 0,
      kurumsal_komisyon: parseFloat(form.kurumsal_komisyon) || 0,
      hya_bireysel_komisyon: parseFloat(form.hya_bireysel_komisyon) || 0,
      hya_kurumsal_komisyon: parseFloat(form.hya_kurumsal_komisyon) || 0,
      ciftlik_fiyat: parseFloat(form.ciftlik_fiyat) || 0,
      ciftlik_fiyat_kdvli: parseFloat(form.ciftlik_fiyat_kdvli) || 0,
      ciftlik_komisyon: parseFloat(form.ciftlik_komisyon) || 0,
      bayi_fiyat: parseFloat(form.bayi_fiyat) || 0,
      bayi_fiyat_kdvli: parseFloat(form.bayi_fiyat_kdvli) || 0,
      bayi_komisyon: parseFloat(form.bayi_komisyon) || 0,
      entegre_fiyat: parseFloat(form.entegre_fiyat) || 0,
      entegre_komisyon: parseFloat(form.entegre_komisyon) || 0,
      komisyonsuz: form.komisyonsuz, aktif: form.aktif,
    };
    if (duzenle) {
      await supabase.from('urunler').update(payload).eq('id', id);
    } else {
      await supabase.from('urunler').insert(payload).select().single();
    }
    setYukleniyor(false);
    navigate('/urunler');
  }

  const isFipgl23 = form.firma_id === FIPGL23_ID;
  const isBroiler = form.firma_id === BROILER_ID;
  const showVet = !isBroiler && (form.satis_tipi === 'veteriner' || form.satis_tipi === 'hepsi');
  const showHya = !isBroiler && form.satis_tipi === 'hepsi';

  return (
    <div>
      <div className="page-header">
        <div>
          <button className="btn btn-ghost btn-sm" onClick={() => navigate('/urunler')} style={{ marginBottom: 8 }}>← Ürünler</button>
          <h1 className="page-title">{duzenle ? 'Ürün Düzenle' : 'Yeni Ürün'}</h1>
        </div>
        <button className="btn btn-primary" onClick={handleKaydet} disabled={yukleniyor}>
          {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
        </button>
      </div>

      {hata && <div className="alert alert-error">{hata}</div>}

      {/* TEMEL BİLGİLER */}
      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginBottom: 16, fontWeight: 700 }}>Temel Bilgiler</h3>
        <div className="form-row cols-2">
          <div className="form-group">
            <label className="label">Firma *</label>
            <select className="select" value={form.firma_id} onChange={e => f('firma_id', e.target.value)}>
              <option value="">Firma Seçin</option>
              {firmalar.map(fi => <option key={fi.id} value={fi.id}>{fi.ad}</option>)}
            </select>
          </div>
          {!isBroiler && (
            <div className="form-group">
              <label className="label">Satış Tipi *</label>
              <select className="select" value={form.satis_tipi} onChange={e => f('satis_tipi', e.target.value)}>
                <option value="veteriner">Sadece Veteriner Hekim</option>
                <option value="hepsi">Her İkisi (Farklı Fiyatla)</option>
              </select>
            </div>
          )}
          <div className="form-group">
            <label className="label">Alt Grup</label>
            <input className="input" value={form.alt_grup} onChange={e => f('alt_grup', e.target.value)} placeholder="Kapsül, Tablet, Flakon..." />
          </div>
          <div className="form-group" style={{ gridColumn: '1/-1' }}>
            <label className="label">Ürün Adı *</label>
            <input className="input" value={form.ad} onChange={e => f('ad', e.target.value)} placeholder="Ürün adını girin..." />
          </div>
          <div className="form-group">
            <label className="label">Maliyet (₺)</label>
            <input className="input" type="number" step="0.01" value={form.maliyet} onChange={e => f('maliyet', e.target.value)} placeholder="0.00" />
          </div>
          <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: 20, paddingTop: 24 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
              <input type="checkbox" checked={form.komisyonsuz} onChange={e => f('komisyonsuz', e.target.checked)} />
              <span>Komisyonsuz</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
              <input type="checkbox" checked={form.aktif} onChange={e => f('aktif', e.target.checked)} />
              <span>Aktif</span>
            </label>
          </div>
        </div>
      </div>

      {/* BROILER FİYATLARI */}
      {isBroiler && (
        <>
          {/* ÇİFTLİK */}
          <div className="card" style={{ marginBottom: 16, borderLeft: '4px solid var(--blue)' }}>
            <h3 style={{ marginBottom: 16, fontWeight: 700 }}>🐔 Çiftlik Fiyatı</h3>
            <div className="form-row cols-2">
              <div className="form-group">
                <label className="label">Fiyat (₺)</label>
                <input className="input" type="number" step="0.01" value={form.ciftlik_fiyat} onChange={e => f('ciftlik_fiyat', e.target.value)} placeholder="0.00" />
              </div>
              {!form.komisyonsuz && (
                <div className="form-group">
                  <label className="label">Komisyon (%)</label>
                  <input className="input" type="number" step="0.01" value={form.ciftlik_komisyon} onChange={e => f('ciftlik_komisyon', e.target.value)} placeholder="0.00" />
                </div>
              )}
            </div>
          </div>

          {/* BAYİ */}
          <div className="card" style={{ marginBottom: 16, borderLeft: '4px solid var(--green)' }}>
            <h3 style={{ marginBottom: 16, fontWeight: 700 }}>🏪 Bayi Fiyatı</h3>
            <div className="form-row cols-2">
              <div className="form-group">
                <label className="label">Fiyat (₺)</label>
                <input className="input" type="number" step="0.01" value={form.bayi_fiyat} onChange={e => f('bayi_fiyat', e.target.value)} placeholder="0.00" />
              </div>
              {!form.komisyonsuz && (
                <div className="form-group">
                  <label className="label">Komisyon (%)</label>
                  <input className="input" type="number" step="0.01" value={form.bayi_komisyon} onChange={e => f('bayi_komisyon', e.target.value)} placeholder="0.00" />
                </div>
              )}
            </div>
          </div>

          {/* ENTEGRE TESİS */}
          <div className="card" style={{ marginBottom: 16, borderLeft: '4px solid var(--accent)' }}>
            <h3 style={{ marginBottom: 16, fontWeight: 700 }}>🏭 Entegre Tesis Fiyatı</h3>
            <div className="form-row cols-2">
              <div className="form-group">
                <label className="label">Fiyat (₺)</label>
                <input className="input" type="number" step="0.01" value={form.entegre_fiyat} onChange={e => f('entegre_fiyat', e.target.value)} placeholder="0.00" />
              </div>
              {!form.komisyonsuz && (
                <div className="form-group">
                  <label className="label">Komisyon (%)</label>
                  <input className="input" type="number" step="0.01" value={form.entegre_komisyon} onChange={e => f('entegre_komisyon', e.target.value)} placeholder="0.00" />
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* VETERİNER FİYATLARI */}
      {showVet && (
        <div className="card" style={{ marginBottom: 16, borderLeft: '4px solid var(--blue)' }}>
          <h3 style={{ marginBottom: 6, fontWeight: 700 }}>🩺 Veteriner Hekim Fiyatları</h3>
          <p style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 16 }}>
            {isFipgl23 ? "Banka / Elden / Kredi Kartı → KDV'siz" : "Banka / Elden → KDV'siz | Kredi Kartı → KDV'li (fatura zorunlu)"}
          </p>
          <div className="form-row cols-2">
            <div className="form-group">
              <label className="label">Banka / Elden Fiyatı (KDV'siz) ₺</label>
              <input className="input" type="number" step="0.01" value={form.banka_fiyat_kdvsiz} onChange={e => f('banka_fiyat_kdvsiz', e.target.value)} placeholder="0.00" />
            </div>
            {!isFipgl23 && (
              <div className="form-group">
                <label className="label">Kredi Kartı Fiyatı (KDV'li) ₺</label>
                <input className="input" type="number" step="0.01" value={form.kk_fiyat_kdvli} onChange={e => f('kk_fiyat_kdvli', e.target.value)} placeholder="0.00" />
              </div>
            )}
            {!form.komisyonsuz && (
              <>
                <div className="form-group">
                  <label className="label">Bireysel Komisyon (%)</label>
                  <input className="input" type="number" step="0.01" value={form.bireysel_komisyon} onChange={e => f('bireysel_komisyon', e.target.value)} placeholder="20.00" />
                </div>
                {!isFipgl23 && (
                  <div className="form-group">
                    <label className="label">Kurumsal Komisyon (%)</label>
                    <input className="input" type="number" step="0.01" value={form.kurumsal_komisyon} onChange={e => f('kurumsal_komisyon', e.target.value)} placeholder="18.00" />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* HASTA YAKINI FİYATLARI */}
      {showHya && (
        <div className="card" style={{ marginBottom: 16, borderLeft: '4px solid var(--accent)' }}>
          <h3 style={{ marginBottom: 6, fontWeight: 700 }}>🏥 Hasta Yakını Fiyatları</h3>
          <p style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 16 }}>
            {isFipgl23 ? "Banka / Elden / Kredi Kartı → KDV'siz" : "Banka / Elden → KDV'siz | Kredi Kartı → KDV'li"}
          </p>
          <div className="form-row cols-2">
            <div className="form-group">
              <label className="label">Banka / Elden Fiyatı (KDV'siz) ₺</label>
              <input className="input" type="number" step="0.01" value={form.hya_banka_fiyat} onChange={e => f('hya_banka_fiyat', e.target.value)} placeholder="0.00" />
            </div>
            {!isFipgl23 && (
              <div className="form-group">
                <label className="label">Kredi Kartı Fiyatı (KDV'li) ₺</label>
                <input className="input" type="number" step="0.01" value={form.hya_kk_fiyat} onChange={e => f('hya_kk_fiyat', e.target.value)} placeholder="0.00" />
              </div>
            )}
            {!form.komisyonsuz && (
              <>
                <div className="form-group">
                  <label className="label">Bireysel Komisyon (%)</label>
                  <input className="input" type="number" step="0.01" value={form.hya_bireysel_komisyon} onChange={e => f('hya_bireysel_komisyon', e.target.value)} placeholder="20.00" />
                </div>
                {!isFipgl23 && (
                  <div className="form-group">
                    <label className="label">Kurumsal Komisyon (%)</label>
                    <input className="input" type="number" step="0.01" value={form.hya_kurumsal_komisyon} onChange={e => f('hya_kurumsal_komisyon', e.target.value)} placeholder="18.00" />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
